export const noop = (...args: any[]): any => {};

export const DEFAULT_DECIMAL_SCALE = 2;
export const DEFAULT_PERCENTAGE_DECIMAL_SCALE = 1;
const ASSETS_URL = 'https://asset.inturn.io';

export const placeholderImageSrc = `${ASSETS_URL}/img/placeholder-item-big%402x.png`;
